<script>
    import { onMount } from "svelte";
    import ModalTitle from "./Modal/ModalTitle.svelte";
    import ModalButtons from "./Modal/ModalButtons.svelte";
    import BrowserOptions from "./Browsing/BrowserOptions.svelte";
    import BrowseTutorialsTable from "./Browsing/BrowseTutorialsTable.svelte";
    import dbData from "../Stores/utilityDBStore.js";
    import sysData from "../Stores/systemStore.js";
    import browseOpts from "../Stores/browseOptionsStore.js";
    import { allCategories } from "../scripts/wpn2Model.js";
    import { filterForMatchingItems } from "../scripts/wpn2Browse.js";

    export let browserType = "none";
    let title;
    let browsableData;
    let filteredData;

    $: title = browserType == "support" ? "Support" : "Unknown";

    const entityNames = allCategories().find((x) => x.name == browserType)?.entities ?? [];
    if (browserType == "support") {
        browsableData = entityNames.flatMap((x) => $sysData[x] ?? []);
        filteredData = browsableData;
    } else {
        browsableData = entityNames.flatMap((x) => $dbData.all[x] ?? []);
        filteredData = browsableData;
    }

    onMount(async () => {
        filteredData = filterForMatchingItems(
            browsableData,
            $browseOpts[browserType]
        );
    });

    function searchBrowserTable(event) {
        browseOpts.updateSearchText(browserType, event.detail.searchText);
        applyFilters();
    }

    function selectorDidChange(event) {
        if (event.detail.name == "dd1") {
            browseOpts.updateDD1(browserType, event.detail.value);
        } else if (event.detail.name == "dd2") {
            browseOpts.updateDD2(browserType, event.detail.value);
        }
        applyFilters();
    }

    function applyFilters() {
        filteredData = filterForMatchingItems(
            browsableData,
            $browseOpts[browserType]
        );
    }

    function exportTable() {
        console.log("Will export");
    }
</script>

<div>
    <ModalTitle {title} on:close />
</div>
<BrowserOptions
    {browserType}
    itemCount={filteredData.length}
    searchText={$browseOpts[browserType].searchText}
    optionsSelected={ { dd1: $browseOpts[browserType].dd1, dd2: $browseOpts[browserType].dd2} }
    on:search={searchBrowserTable}
    on:selector-changed={selectorDidChange}
/>

{#if browserType == "support"}
    <BrowseTutorialsTable {filteredData} on:item-selected />
{/if}
<footer>
    <slot name="footer">
        {#if browserType == "support"}
            <ModalButtons actions={["close", "help"]} on:close on:help />
        {:else}
            <ModalButtons
                actions={["close", "export", "create"]}
                on:close
                on:create
                on:export={exportTable}
            />
        {/if}
    </slot>
</footer>
